import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HelpSidebar = ({ currentStep }) => {
  const getStepHelp = () => {
    switch (currentStep) {
      case 1:
        return {
          title: 'Bedrijfsgegevens Tips',
          items: [
            {
              icon: 'Building',
              title: 'KvK Nummer',
              description: 'Uw 8-cijferige Kamer van Koophandel nummer is verplicht voor verificatie.'
            },
            {
              icon: 'Shield',
              title: 'BTW Nummer',
              description: 'Nederlandse BTW-identificatie begint altijd met "NL" gevolgd door 12 tekens.'
            },
            {
              icon: 'Phone',
              title: 'Contactgegevens',
              description: 'Gebruik een zakelijk e-mailadres en telefoonnummer voor professionaliteit.'
            }
          ]
        };
      case 2:
        return {
          title: 'Diensten Selectie Tips',
          items: [
            {
              icon: 'Zap',
              title: 'Meerdere Diensten',
              description: 'U kunt meerdere categorieën selecteren om meer klanten te bereiken.'
            },
            {
              icon: 'Award',
              title: 'Specialisatie',
              description: 'Vul specifieke merken en capaciteiten in voor betere matching.'
            },
            {
              icon: 'Users',
              title: 'Bedrijfsprofiel',
              description: 'Een goede beschrijving helpt klanten uw expertise te begrijpen.'
            }
          ]
        };
      case 3:
        return {
          title: 'Werkgebied Tips',
          items: [
            {
              icon: 'Map',
              title: 'Service Straal',
              description: 'Kies een realistische straal die u kunt bedienen zonder kwaliteitsverlies.'
            },
            {
              icon: 'MapPin',
              title: 'Provincies',
              description: 'Selecteer alleen provincies waar u daadwerkelijk projecten uitvoert.'
            },
            {
              icon: 'Navigation',
              title: 'Postcodes',
              description: 'Specifieke postcodes helpen bij lokale zoekopdrachten.'
            }
          ]
        };
      case 4:
        return {
          title: 'Documenten Tips',
          items: [
            {
              icon: 'FileText',
              title: 'KvK Uittreksel',
              description: 'Moet recenter zijn dan 3 maanden voor geldige verificatie.'
            },
            {
              icon: 'Shield',
              title: 'Verzekering',
              description: 'Aansprakelijkheidsverzekering is verplicht voor alle providers.'
            },
            {
              icon: 'Award',
              title: 'Certificaten',
              description: 'Upload relevante certificaten om uw expertise te tonen.'
            }
          ]
        };
      default:
        return null;
    }
  };

  const stepHelp = getStepHelp();

  if (!stepHelp) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-6 sticky top-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4 flex items-center space-x-2">
        <Icon name="HelpCircle" size={20} />
        <span>{stepHelp?.title}</span>
      </h3>
      <div className="space-y-4">
        {stepHelp?.items?.map((item, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={item?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="font-medium text-foreground text-sm mb-1">
                {item?.title}
              </h4>
              <p className="text-xs text-muted-foreground">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Contact Support */}
      <div className="mt-6 pt-4 border-t border-border">
        <h4 className="font-medium text-foreground text-sm mb-2">
          Hulp Nodig?
        </h4>
        <p className="text-xs text-muted-foreground mb-3">
          Ons support team helpt u graag bij vragen over de registratie.
        </p>
        <Button
          variant="outline"
          size="sm"
          fullWidth
          iconName="MessageCircle"
          iconPosition="left"
        >
          Contact Support
        </Button>
      </div>
      {/* Trust Signals */}
      <div className="mt-4 p-3 bg-success/5 border border-success/20 rounded-lg">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Shield" size={16} color="var(--color-success)" />
          <span className="text-sm font-medium text-success">Veilig & Vertrouwd</span>
        </div>
        <p className="text-xs text-muted-foreground">
          Uw gegevens worden veilig opgeslagen volgens AVG/GDPR richtlijnen.
        </p>
      </div>
    </div>
  );
};

export default HelpSidebar;